import React, { useEffect, createElement } from 'react';
import { trackCTAClick, trackCalendlyClick, trackExternalLink } from '../utils/mixpanel';
export function Header() {
  const handleStartTrialClick = () => {
    trackCTAClick('Start Free Trial', 'header', 'https://calendly.com/alex-thruline/cad-sync-meeting');
    trackCalendlyClick('Start Free Trial', 'header');
  };
  const handleThrulineLogoClick = () => {
    trackExternalLink('Thruline Logo', 'https://www.thruline.ai', 'header');
  };
  // Initialize Apollo tracking script
  useEffect(() => {
    const initApollo = () => {
      const n = Math.random().toString(36).substring(7);
      const o = document.createElement('script');
      o.src = 'https://assets.apollo.io/micro/website-tracker/tracker.iife.js?nocache=' + n;
      o.async = true;
      o.defer = true;
      o.onload = function () {
        if (window.trackingFunctions) {
          window.trackingFunctions.onLoad({
            appId: '6632671b67c285055b13c2ad'
          });
        }
      };
      document.head.appendChild(o);
    };
    initApollo();
  }, []);
  return <header className="sticky top-0 z-50 bg-white border-b border-slate-200" data-id="element-79">
      <div className="max-w-7xl mx-auto px-6 py-4" data-id="element-80">
        <div className="flex items-center justify-between" data-id="element-81">
          {/* Logo - Swapped order: CAD Sync first, then Thruline logo */}
          <div className="flex items-center gap-4" data-id="element-82">
            <div className="flex flex-col" data-id="element-83">
              <span className="text-xl font-bold text-slate-900" data-id="element-84">CAD Sync</span>
              <span className="text-xs text-slate-500 font-medium" data-id="element-85">
                Powered by Thruline
              </span>
            </div>
            <a href="https://www.thruline.ai" target="_blank" rel="noopener noreferrer" onClick={handleThrulineLogoClick} className="hover:opacity-80 transition-opacity" data-id="element-86">
              <img src="https://thruline-public.s3.us-west-1.amazonaws.com/brand/logos/png/logo-light-trans.png" alt="Thruline" className="h-8" data-id="element-87" />
            </a>
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4" data-id="element-88">
            <a href="https://calendly.com/alex-thruline/cad-sync-meeting" target="_blank" rel="noopener noreferrer" onClick={handleStartTrialClick} className="px-6 py-2.5 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all hover:scale-[1.02] shadow-thruline" data-id="element-89">
              Start Free Trial
            </a>
          </div>

          {/* Mobile CTA */}
          <div className="md:hidden" data-id="element-90">
            <a href="https://calendly.com/alex-thruline/cad-sync-meeting" target="_blank" rel="noopener noreferrer" onClick={handleStartTrialClick} className="px-6 py-2.5 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all shadow-thruline" data-id="element-91">
              Start Free Trial
            </a>
          </div>
        </div>
      </div>
    </header>;
}